<template>
  <div>
    <div class="BkHeight">
      <div class="BkHeight-W">
        <div class="Homeinput"><Homseach></Homseach></div>
        <div class="BkHeight_conent">
          <div class="BkHeight_conent_header">
            <p>
              <span>Block Detail</span>
            </p>
          </div>
          <div class="BkHeight_conent_Ul">
            <ul>
              <li>
                <p>BK Hash :</p>
                <p class="notranslate">
                  {{ Hash }}
                  <img
                    src="@/assets/pc/BkHash/BkHash1.png"
                    v-clipboard:copy="Hash"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                    @click="msg(index)"
                  />
                </p>
              </li>
              <li>
                <p>Block Height :</p>
                <router-link
                  :to="{
                    name: 'BkHeight',
                    query: { height: this.Height },
                  }"
                >
                  <p class="notranslate bacs">{{ Height }}</p>
                </router-link>
              </li>
              <li>
                <p>Previous Block Hash :</p>
                <p class="notranslate" @click="bHash(BlockHash)">
                  {{ BlockHash }}
                </p>
              </li>
              <li>
                <p>Packer :</p>
                <p class="notranslate" @click="goAddress(packeraddress)">
                  <img
                    :src="packerLogo"
                    style="width: 24px; height: 24px; border-radius: 50%"
                  /><span>{{ Packer }}</span>
                </p>
              </li>
              <li>
                <p>Time :</p>
                <p class="notranslate">{{ Time }}</p>
              </li>
              <li>
                <p>Size :</p>
                <p class="notranslate">
                  {{ Number(Size).toLocaleString() }} bytes
                </p>
              </li>
              <li>
                <p>Tx Count :</p>
                <p class="notranslate">{{ TxCount }}</p>
              </li>
              <li>
                <p>Block signer :</p>
                <!-- <p class="notranslate">{{ Blocksigner }} signers (See all)</p> -->
                <p>
                  <el-collapse v-model="activeNames" @change="handleChange">
                    <el-collapse-item
                      :title="Blocksigner.length + ' signers (See all)'"
                      name="1"
                    >
                      <span class="listbox">
                        <div
                          class="listboxli"
                          v-for="(item, index) in Blocksigner"
                          :key="index"
                          @click="form1(item)"
                        >
                          {{ item }}
                        </div>
                        <!-- <div class="listboxli"></div> -->
                        <!-- <div class="listboxli">1K6o2ihyk3BC7MG53...</div>
                        <div class="listboxli">1K6o2ihyk3BC7MG53...</div>
                        <div class="listboxli">1K6o2ihyk3BC7MG53...</div>
                        <div class="listboxli">1K6o2ihyk3BC7MG53...</div>
                        <div class="listboxli">1K6o2ihyk3BC7MG53...</div>
                        <div class="listboxli">1K6o2ihyk3BC7MG53...</div> -->
                      </span>
                    </el-collapse-item>
                  </el-collapse>
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div class="Transction">
          <div class="Blocks">
            <div class="Block_Top">
              <span
                >Transactions<b class="notranslate">({{ total }})</b></span
              >
              <span>
                <!-- <el-pagination
                  class="notranslate"
                  :current-page.sync="PaginationIndex"
                  background
                  layout="prev, pager,
      next"
                  @current-change="CurrentChange"
                  :total="total"
                >
                </el-pagination> -->
              </span>
            </div>
            <div v-show="list2.length > 0">
              <div class="Block_list">
                <ul class="block_list_Top">
                  <li>Txn Hash</li>
                  <li>Type</li>
                  <li>Age</li>
                  <li>From</li>
                  <li>To</li>
                  <li>Amount</li>
                  <!-- <li>Gas</li> -->
                </ul>
              </div>
              <div class="Block_List_center">
                <ul>
                  <li v-for="(item, index) in list2" :key="index">
                    <p>
                      <span @click="TxHash(index)">{{ item.txHash1 }}</span>
                    </p>
                    <p class="notranslate">{{ item.type }}</p>
                    <p class="notranslate">
                      {{ item.tradeTime }}
                      <span class="Hover1">
                        <span class="Hover"
                          >{{ TimeDate1[index]
                          }}<i class="iconfont">&#xe600;</i></span
                        >
                      </span>
                    </p>
                    <p>
                      <span
                        @click="form(index)"
                        v-if="
                          item.type != 'Unstake' &&
                          item.fromAddress != 'Unpledge' &&
                          item.type != 'Bonus'
                        "
                      >
                        {{ item.fromAddress1 }}
                      </span>
                      <span class="bukdianj" v-if="item.type == 'Bonus'"
                        >Bonus</span
                      >
                      <span class="bukdianj" v-if="item.type == 'Unstake'"
                        >Unstake</span
                      >
                    </p>

                    <p>
                      <span v-if="item.toAddress == ''" style="color: #999"
                        >...</span
                      >
                      <span v-else>
                        <span
                          @click="to(index)"
                          class="kedian"
                          v-if="
                            item.type != 'Stake' &&
                            item.toAddress[0] != 'Pledge'
                          "
                          >{{ item.toAddress1 }}</span
                        >
                        <span v-else>Stake</span>
                      </span>
                    </p>
                    <p
                      v-if="item.standard == 'ERC-721' && item.type1 == 7"
                      style="color: #8d8d8d"
                    >
                      <img
                        :src="item.logo"
                        v-if="item.tokenAmount == ''"
                        style="width: 24px; height: 24px; border-radius: 50%"
                      />

                      <img
                        :src="item.logo"
                        v-if="item.tokenAmount !== ''"
                        style="height: 34px; border-radius: 4px"
                      />{{ item.contractName }}
                    </p>
                    <p
                      v-if="item.standard == 'ERC-20' && item.type1 == 7"
                      style="color: #fff; cursor: pointer"
                      @click="cHash(index)"
                    >
                      <!-- {{ item.tokenAmount }} -->
                      <span v-if="item.tokenAmount.length > 8">
                        {{ item.tokenAmount.slice(0, 8) }}...</span
                      >
                      <span v-else>{{ item.tokenAmount }}</span>
                      <img
                        :src="item.logo"
                        style="width: 24px; height: 24px; border-radius: 50%"
                      />
                      <span v-if="item.symbol.length > 10"
                        >{{ item.symbol.slice(0, 8) }}...</span
                      >
                      <span v-else> {{ item.symbol }}</span>
                    </p>
                    <p
                      v-if="item.standard == 'ERC-20' && item.type1 == 8"
                      style="color: #fff; cursor: pointer"
                      @click="cHash(index)"
                    >
                      <span v-if="item.tokenAmount.length > 8">
                        {{
                          item.tokenAmount.slice(0, 8)
                        }}...</span
                      >
                      <span v-else>
                        {{ item.tokenAmount }}
                        <!-- {{ Number(item.tokenAmount).toLocaleString() }} -->
                        <!-- {{
                          new Intl.NumberFormat("en-US", {
                            minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                            maximumFractionDigits: 10,
                          }).format(item.tokenAmount)
                        }} -->
                      </span>

                      <img
                        :src="item.logo"
                        style="width: 24px; height: 24px; border-radius: 50%"
                      />{{ item.symbol }}
                    </p>
                    <!-- 合约执行 -->
                    <p
                      v-if="
                        item.standard == 'ERC-721' &&
                        item.type1 == 8 &&
                        item.tokenAmount !== ''
                      "
                      style="color: #fff; cursor: pointer"
                      @click="cHash(index)"
                    >
                      <!-- //   item.logo -->
                      <img
                        :src="item.logo"
                        style="height: 34px; border-radius: 4px"
                      />{{ item.contractName }}
                      {{ item.tokenAmount.split(",")[0] }}
                    </p>
                    <p
                      v-if="
                        item.standard == 'ERC-721' &&
                        item.type1 == 8 &&
                        item.tokenAmount == ''
                      "
                      style="color: #8d8d8d"
                    >
                      <!-- //   item.logo -->
                      <img
                        v-if="item.functions == 'Contract Execute'"
                        :src="imgurl"
                        style="width: 24px; height: 24px; border-radius: 50%"
                      />
                      <img
                        v-if="item.functions !== 'Contract Execute'"
                        :src="item.logo"
                        style="width: 24px; height: 24px; border-radius: 4px"
                      />{{ item.contractName }}
                      {{ item.tokenAmount.split(",")[0] }}
                    </p>
                    <p
                      style="color: #8d8d8d"
                      v-if="
                        (item.type1 !== 8 || item.type1 !== 7) &&
                        item.standard == ''
                      "
                    >
                      <!-- {{ item.amount }} -->
                      {{
                        new Intl.NumberFormat("en-US", {
                          minimumFractionDigits: 0, // 设置为足够大的值以保留所有小数位
                          maximumFractionDigits: 10,
                        }).format(item.amount)
                      }}
                      TTOS
                    </p>
                    <!-- <p v-if="item.amount == ''">123....</p> -->
                  </li>
                </ul>
              </div>
              <div class="Block_List_Bottom">
                <el-pagination
                  class="notranslate"
                  :current-page.sync="PaginationIndex"
                  background
                  layout="prev, pager,
      next"
                  @current-change="CurrentChange"
                  :total="total"
                >
                </el-pagination>
              </div>
            </div>
            <div v-show="list2.length <= 0">
              <EmptyState />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Homseach from "@/components/pc/serch.vue";
import Homeinput from "../Home/Home_input";
import Pagination from "../BlockList/Pagination3.vue";
import Pagination2 from "../BlockList/Pagination";
import EmptyState from "../EmptyState/EmptyState.vue";
import { BlockDetail, GetblockDetail } from "@/assets/server/api";

import {
  timestampConvertTime,
  formatSeconds,
  getSubStr,
  listTypea,
  countDecimalPlaces,
  formattedNumber,
  
} from "@/utils/utils";
export default {
  data() {
    return {
      activeNames: ["0"],
      Hash: "",
      Height: "",
      BlockHash: "",
      Packer: "",
      packerLogo: "",
      Time: "",
      Size: "",
      TxCount: "",
      Blocksigner: "",
      list2: [],
      txHash: [],
      fromAddress: [],
      toAddress: [],
      data: [],
      data2: [],
      data3: [],
      Time: [],
      total: null,
      Type: "",
      PaginationIndex: 1,
      packeraddress: "",
      // copyContent: "",
      TimeDate: [],
      TimeDate1: [],
      Page1: "",
      imgurl1: require("@/assets/pc/Index/vers.png"),
      imgurl: require("@/assets/pc/Index/indexlogo.png"),
      imgurlnft: require("@/assets/pc/Index/nft.png"),
    };
  },
  components: {
    Homeinput,
    Pagination,
    EmptyState,
    Homseach,
  },
  computed: {},
  created() {
    this.TransactionsList();
  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.goBack, false);
    }
  },

  destroyed() {
    window.removeEventListener("popstate", this.goBack, false);
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  methods: {
    check_is_img(url) {
      return (
        url.match(/\.(jpeg|jpg|gif|png|GIF|PNG|JPG|JPEG|SVG|svg)$/) != null
      );
    },
    goBack() {
      //this.$router.replace({ path: "/pc/BlockList" });
      history.go(-1);
    },
    handleChange(val) {
      // console.log(val);
    },
    CurrentChange(e) {
      this.PaginationIndex = e;
      this.Page1 = this.getContextData("tiaozhuan") || e;
      this.TransactionsList();
    },
    TransactionsList() {
      let _this = this;
      const params = {
        blockHash: this.$route.query.blockHash,
        pageNum: this.PaginationIndex,
        pageSize: 10,
      };
      // console.log(params);
      const formData = new FormData();
      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      GetblockDetail(formData).then((res) => {
        // console.log(res);
        // console.log(res.result.blockInfo.packerName);
        _this.list2 = res.result.tradeList;
        //     console.log(_this.list2);
        _this.total = res.result.blockInfo.tradeNums;

        this.Hash = res.result.blockInfo.blockHash;
        this.Height = res.result.blockInfo.height;
        this.BlockHash = res.result.blockInfo.prevHash;
        this.packeraddress = res.result.blockInfo.packer;

        //  this.Packer = res.result.blockInfo.packerName;
        //  console.log(this.Packer);
        if (res.result.blockInfo.packerName == "") {
          this.Packer = res.result.blockInfo.packer;
        } else {
          this.Packer = res.result.blockInfo.packerName;
        }

        if (res.result.blockInfo.packerLogo == "") {
          this.packerLogo = this.imgurl1;
        } else {
          this.packerLogo = res.result.blockInfo.packerLogo;
        }
        this.Time = res.result.blockInfo.blockTime;
        this.Size = res.result.blockInfo.bytes;
        this.TxCount = res.result.blockInfo.tradeNums;
        this.Blocksigner = res.result.blockInfo.signStr.split(",");
        var calctime = new Date();
        let strdate = Math.floor(calctime.getTime() / 1000);
        let timestampa = Math.floor(
          this.gltime(res.result.blockInfo.blockTime) / 1000
        );
        // console.log(timestampa);
        // console.log(strdate);
        var s2 = strdate - timestampa;
        if (s2 <= 0) {
          s2 = 1;
        }
        this.Time = formatSeconds(s2);

        for (let i = 0; i < _this.list2.length; i++) {
          _this.list2[i].tokenAmount=formattedNumber( _this.list2[i].tokenAmount);
          if (_this.list2[i].amount == "") {
            _this.list2[i].amount == "...";
          }
          //   var aa='12323213.343434';
          //  console.log(countDecimalPlaces(_this.list2[i].tokenAmount));
          //  console.log(countDecimalPlaces(aa));

          // if(countDecimalPlaces(_this.list2[i].tokenAmount)>8){
          // _this.list2[i].tokenAmount =Number((_this.list2[i].tokenAmount).toString().match(/^\d+(?:\.\d{0,8})?/));
          // }
          // _this.list2[i].tokenAmount=(parseFloat( _this.list2[i].tokenAmount)).toFixed(8)
          //  console.log( _this.list2.toAddress);
          _this.list2[i].txHash1 = getSubStr(_this.list2[i].txHash, 0, 6);
          _this.list2[i].toAddress1 = getSubStr(_this.list2[i].toAddress, 0, 6);
          _this.list2[i].fromAddress1 = getSubStr(
            _this.list2[i].fromAddress,
            0,
            6
          );
          _this.list2[i].fromEvmAddress1 = getSubStr(
            _this.list2[i].fromEvmAddress,
            0,
            6
          );
          _this.list2[i].toEvmAddress1 = getSubStr(
            _this.list2[i].toEvmAddress,
            0,
            6
          );
          //  console.log(_this.list2);
          _this.list2[i].type1 = _this.list2[i].type;
          _this.list2[i].type = listTypea(_this.list2[i].type);

          if (
            _this.list2[i].standard !== "ERC-20" &&
            (_this.list2[i].logo == "" ||
              this.check_is_img(_this.list2[i].logo) == false)
          ) {
            if (_this.list2[i].type1 == "7") {
              _this.list2[i].logo = _this.imgurl;
            } else {
              _this.list2[i].logo = _this.imgurlnft;
            }
          }
          if (
            _this.list2[i].standard == "ERC-20" &&
            (_this.list2[i].logo == "" ||
              this.check_is_img(_this.list2[i].logo) == false)
          ) {
            //_this.list2[i].logo =_this.imgurl;
            if (_this.list2[i].logo !== "") {
              _this.list2[i].logo = _this.list2[i].logo;
            } else {
              _this.list2[i].logo = _this.imgurl;
            }
          }
          if (
            _this.list2[i].type1 == "8" &&
            _this.list2[i].standard == "ERC-721" &&
            _this.list2[i].nftImageList !== ""
          ) {
            var images = JSON.parse(_this.list2[i].nftImageList);
            // console.log(images);
            _this.list2[i].logo = images[0];
            if (this.check_is_img(_this.list2[i].logo) == false) {
              _this.list2[i].logo = _this.imgurlnft;
            }
          } else {
            if (_this.list2[i].standard == "ERC-721") {
              _this.list2[i].logo = _this.imgurlnft;
            }
            // if (_this.list2[i].standard == "ERC-721" ) {
            //        if( _this.list2[i].logo ==' '){
            //   _this.list2[i].logo = _this.imgurlnft;
            // }else{
            //   _this.list2[i].logo = _this.list2[i].logo;
            // }
            // }
          }
          if (
            _this.list2[i].standard == "ERC-721" &&
            _this.list2[i].type1 == "7"
          ) {
            if (_this.list2[i].logo == " ") {
              _this.list2[i].logo = _this.imgurl;
            } else {
              _this.list2[i].logo = _this.list2[i].logo;
            }
          }
          // if (_this.list2[i].standard=='ERC-20' &&_this.list2[i].logo!=="") {
          //   _this.list2[i].logo =_this.imgurl;
          // }else{
          //   _this.list2[i].logo =_this.list2[i].logo;
          // }
          if (_this.list2[i].type == 8) {
            _this.list2[i].type = _this.list2[i].functions;
            _this.list2[i].toAddress1 = _this.list2[i].toEvmAddress1;
            _this.list2[i].fromAddress1 = _this.list2[i].fromEvmAddress1;
            _this.list2[i].toAddress = _this.list2[i].toEvmAddress;
            _this.list2[i].fromAddress = _this.list2[i].fromEvmAddress;
          }
          if (_this.list2[i].type == 7) {
            _this.list2[i].type = "ContractCreation";
          }
          let UTCTime1 =
            res.result.tradeList[i].tradeTime -
            this.getClientTimezone * 3600000;
          this.TimeDate1[i] = timestampConvertTime(UTCTime1);
          let timestamp = Math.floor(
            this.gltime(_this.list2[i].tradeTime) / 1000
          );
          var s = strdate - timestamp;
          if (s <= 0) {
            s = 1;
          }
          _this.list2[i].tradeTime = formatSeconds(s);
          if (_this.list2[i].nftNameList !== "") {
            _this.list2[i].contractName = JSON.parse(
              _this.list2[i].nftNameList
            )[0];
            //  console.log( _this.list2[i].contractName);
          }
          if (
            _this.list2[i].standard == "ERC-721" &&
            _this.list2[i].type1 == "7" &&
            _this.list2[i].contractName == ""
          ) {
            _this.list2[i].contractName = getSubStr(
              _this.list2[i].contractAddress,
              0,
              3
            );
          }
          if (
            _this.list2[i].standard == "ERC-20" &&
            _this.list2[i].type1 == "7"
          ) {
            if (_this.list2[i].symbol == "" || _this.list2[i].symbol == null) {
              _this.list2[i].symbol = _this.list2[i].contractName;
            }
          }

          // this.list2[i].toAddress = _this.list2[i].toAddress.split(",");
        }
        // console.log(_this.list2);

        //this.list[2].BlockHeight = res.result.tradeTime;
      });
    },
    // let params = {
    //     contractAddress: this.list1[index].contractAddress,
    //     tokenId:tokenid[0]
    //   };
    //   this.$router.push({ path: "/pc/NFTslistdetail", query: params });
    cHash(index) {
      // console.log(this.list2);
      if (
        this.list2[index].type1 == 8 &&
        this.list2[index].standard == "ERC-20"
      ) {
        //  console.log(111);
        let params = {
          contractAddress: this.list2[index].contractAddress,
        };
        this.$router.push({ path: "/pc/Overview", query: params });
      } else if (
        this.list2[index].type1 == 8 &&
        this.list2[index].standard == "ERC-721"
      ) {
        let params = {
          contractAddress: this.list2[index].contractAddress,
          tokenId: this.list2[index].tokenAmount.split(",")[0],
        };
        this.$router.push({ path: "/pc/NFTslistdetail", query: params });
      } else if (this.list2[index].type1 == 7) {
        let params = {
          contractAddress: this.list2[index].contractAddress,
        };
        this.$router.push({ path: "/pc/Overview", query: params });
      }
    },
    goAddress(index) {
      this.$router.push({ path: "/pc/BkHash", query: { query: index } });
    },
    form1(index) {
      this.$router.push({ path: "/pc/BkHash", query: { query: index } });
    },
    form(index) {
      let params = this.list2[index].fromAddress;
      this.$router.push({ path: "/pc/BkHash", query: { query: params } });
    },
    gltime(i) {
      const toDate = new Date(i);

      var d = toDate;
      var localTime = d.getTime();
      var localOffset = d.getTimezoneOffset() * 60000;
      var utc = localTime + localOffset;
      var offset = this.getClientTimezone;
      var korean = utc + 3600000 * offset;
      var nd = korean;
      return nd;
    },
    bHash(index) {
      //  console.log(index);
      this.$router.push({ path: "/pc/BkDetail", query: { blockHash: index } });
      this.TransactionsList();
    },
    to(index) {
      let params = this.list2[index].toAddress;
      this.$router.push({ path: "/pc/BkHash", query: { query: params } });
    },
    TxHash(index) {
      //  console.log(this.list2);
      let params = {
        txHash: this.list2[index].txHash,
        type: this.list2[index].type1,
        standard: this.list2[index].standard,
      };
      //   console.log(params);
      this.$router.push({ path: "/pc/To", query: params });
    },
    onCopy(e) {
      // console.log(e);
      this.$message({
        message: "Copy successful",
        type: "success",
        center: true,
        duration: "500",
      });
    },
    onError(e) {
      this.$message.error("copy failed");
    },
    getContextData: function (key) {
      const str = sessionStorage.getItem(key);
      if (typeof str == "string") {
        try {
          return JSON.parse(str);
        } catch (e) {
          return str;
        }
      }
      return;
    },
  },
};
</script>
<style lang="less">
// .el-collapse {
//   background: red !important;
// }
// .el-collapse-item {
//   background: red !important;
// }
.el-collapse-item__wrap {
  background: #0b0c0f !important;
  border: none !important;
}
.el-collapse-item__header {
  background: #0b0c0f !important;
  border: none !important;
  color: #fff !important;
}
.el-collapse {
  border: none !important;
  margin-top: -12px;
}
.el-collapse-item__arrow {
  display: none;
}
.el-dialog__title {
  margin-left: 80px;
  font-size: 14px;
  font-family: Poppins-Medium, Poppins;
  font-weight: 500;
  color: #898b8d;
}
.v-modal {
  opacity: 0.8 !important;
  background: #13161b !important;
}
.el-dialog {
  background: rgba(0, 0, 0, 0.8);
  width: 702px !important;
  height: 385px !important;
  background: #000000;
  border-radius: 20px 20px 20px 20px;
  margin-top: 260px !important;
  left: 100px;
}
.el-dialog__body {
  padding: 0 !important;
}
.el-button--text {
  color: #fff !important;
  cursor: pointer;
}
</style>
<style lang="less" scoped>
@import url("https://at.alicdn.com/t/font_3404326_3s5grzrpcqy.css");
.BkHeight {
  width: 100%;
  background: #13161b;
  .BkHeight-W {
    width: 1160px;
    margin: 0 auto;
    background: #13161b;
    .Homeinput {
      padding: 40px 0;
    }
    .BkHeight_conent {
      // border: 1px solid red;
      padding-top: 1px;
      width: 1160px;
      // height: 478px;
      background: #0b0c0f;
      opacity: 1;
      border-radius: 16px 16px 16px 16px;
      // padding: 20px 20px 0 20px;
      margin-bottom: 20px;
      .BkHeight_conent_header {
        p {
          margin-top: 30px;
          span:nth-child(1) {
            font-size: 18px;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #ffffff;
            -webkit-background-clip: text;
            //  border: 1px solid red;
            margin-left: 40px;
          }
        }
      }
      .BkHeight_conent_Ul {
        //border: 1px solid yellow;
        ul {
          margin-left: 40px;
          margin-top: 30px;
          li {
            display: flex;

            // height: 46px;
            p:nth-child(1) {
              // flex: 0 0 9%;
              font-size: 14px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #898b8d;
              line-height: 46px;
              -webkit-background-clip: text;
              margin-right: 223px;
              // border: 1px solid red;
              width: 200px;
            }
            p:nth-child(2) {
              flex: 0 0 60%;
              // border: 1px solid green;
              font-size: 14px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #898b8d;
              line-height: 46px;

              -webkit-background-clip: text;
              img {
                width: 24px;
                height: 24px;
                margin-top: 10px;
                // margin: 10px 0 0 20px;
                cursor: pointer;
                //border: 1px solid red;
              }
            }
          }
          li:nth-child(2) {
            .bacs {
              cursor: pointer;
              color: #fff;
            }
            p:nth-child(2) {
              cursor: pointer;
              color: #fff;
            }
          }
          li:nth-child(3) {
            p:nth-child(2) {
              position: relative;
              cursor: pointer;
              color: #fff;

              .Hover1 {
                display: none;
                .Hover {
                  padding: 3px 10px;
                  display: inline-block;
                  line-height: 20px;
                  position: absolute;
                  top: -10px;
                  left: 10px;
                  background-color: #0b0c0f;
                  border-radius: 5px;
                  i {
                    position: absolute;
                    top: 18px;
                    left: 40%;
                    transform: rotate(180deg);
                    color: #3c485c;
                  }
                }
              }
            }
            p:nth-child(2):hover {
              .Hover1 {
                display: block !important;
              }
            }
          }
          li:nth-child(4) {
            p:nth-child(2) {
              cursor: pointer;
              color: #fff;
              span {
                margin-left: 6px;
              }
            }
          }
          li:nth-child(8) {
            p:nth-child(2) {
              line-height: 0;
              margin-top: 22px;
              color: #fff;
              .listbox {
                // color: rgba(255, 255, 255, 0.9);
                // color: red;
                display: flex;
                flex-wrap: wrap;
                margin-top: 10px;
                .listboxli {
                  width: 160px;
                  color: #fff;
                  cursor: pointer;
                  padding-right: 30px;
                  font-size: 12px;
                  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                  font-weight: 400;
                  overflow: hidden; /*内容会被修剪，并且其余内容是不可见的*/
                  text-overflow: ellipsis; /*显示省略符号来代表被修剪的文本。*/
                  white-space: nowrap; /*文本不换行*/
                }
                .listboxli:hover {
                  color: #00a870;
                  cursor: pointer;
                }
              }
              span:nth-child(1) {
                line-height: 22px;
              }
            }
            img {
              width: 24px;
              height: 24px;
              // margin-top: 18px;
            }
            .xiegang {
              line-height: 62px !important;
            }
          }
        }
      }
    }
    .Transction {
      padding-bottom: 20px;
      .Blocks {
        // border: 1px solid red;
        padding: 20px 20px;
        width: 1160px;
        // height: 1300px;
        background: #0b0c0f;
        opacity: 1;
        border-radius: 16px 16px 16px 16px;
        .Block_Top {
          margin-bottom: 24px;
          display: flex;
          span {
            flex: 1;
          }
          span:nth-child(1) {
            font-size: 18px;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #ffffff;
            line-height: 26px;
            -webkit-background-clip: text;
          }
        }
        .Block_list {
          .block_list_Top {
            // border: 1px solid red;
            width: 1120px;
            height: 60px;
            background: #14151a;
            border-radius: 10px 10px 10px 10px;
            opacity: 1;
            display: flex;
            li {
              flex: 0 0 16%;
              font-size: 16px;
              font-family: Source Han Sans CN-Regular, Source Han Sans CN;
              font-weight: 400;
              color: #898b8d;
              line-height: 62px;
              -webkit-background-clip: text;
              text-align: center;
            }
            li:nth-child(3) {
              flex: 0 0 16.5%;
            }
            li:nth-child(6) {
              flex: 0 0 18.5%;
            }
          }
        }
        .Block_List_center {
          ul {
            min-height: 130px;
            // padding: 0 20px;
            li {
              display: flex;
              height: 62px;
              border-bottom: 1px solid #22252e;
              line-height: 62px;
              p {
                flex: 0 0 16%;
                font-size: 12px;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                font-weight: 400;
                color: #ffffff;
                -webkit-background-clip: text;
                text-align: center;
                img {
                  border-radius: 50%;
                }
              }
            }

            li:last-child {
              border-bottom: none !important;
            }
            p:nth-child(1) {
              color: #fff;
              span {
                cursor: pointer;
              }
            }
            p:nth-child(1):hover {
              color: #00a870;
            }
            p:nth-child(2) {
              color: #898b8d;
            }
            p:nth-child(3) {
              color: #898b8d;
              flex: 0 0 16.5%;
              position: relative;
              cursor: default;
              .Hover1 {
                display: none;
                .Hover {
                  width: 196px;
                  padding: 3px 10px;
                  display: inline-block;
                  line-height: 20px;
                  position: absolute;
                  top: -10px;
                  left: 0px;
                  background-color: #3c485c;
                  border-radius: 5px;
                  i {
                    position: absolute;
                    top: 18px;
                    left: 40%;
                    transform: rotate(180deg);
                    color: #3c485c;
                  }
                }
              }
            }
            p:nth-child(3):hover {
              .Hover1 {
                display: block !important;
              }
            }
            p:nth-child(4) {
              span {
                color: #fff !important;
                cursor: pointer;
              }
              span:hover {
                color: #00a870 !important;
              }
              .bukdianj {
                color: rgba(255, 255, 255, 0.9) !important;
                cursor: text;
              }
            }

            p:nth-child(5) {
              color: rgba(255, 255, 255, 0.9);
              .kedian {
                color: #fff !important;
                cursor: pointer;
              }
              .kedian:hover {
                color: #00a870 !important;
              }
            }
            p:nth-child(6) {
              flex: 0 0 18.5%;
              color: rgba(255, 255, 255, 0.9);
              img {
                // width: 34px;
                height: 34px;
                margin-top: 16px;
                margin-right: 10px;
              }
            }
            p:nth-child(7) {
              color: rgba(255, 255, 255, 0.9);
            }
          }
        }
        .Block_List_Bottom {
          margin-top: 20px;
        }
      }
    }
  }
}
.yanca {
  color: rgba(255, 255, 255, 0.9) !important;
  cursor: text;
}
.el-pagination {
  display: flex;
  justify-content: right;
  ::v-deep button {
    min-width: 24px !important;
    height: 24px !important;
    font-size: 12px;
    color: #fff !important;
    background: none !important;
    // background: #3c485c !important;
    border-radius: 4px 4px 4px 4px !important;
  }
  ::v-deep ul {
    li {
      min-width: 24px !important;
      height: 24px !important;
      background: none !important;
      //border-radius: 4px 4px 4px 4px !important;
      font-size: 12px;
      font-family: aaa;
      font-weight: 400 !important;
      color: #ffffff !important;
      line-height: 20px !important;
      margin: 0 4px !important;
      padding: 2px 8px !important;
    }
    .active {
      background: #22252e !important;
    }
    .more::before {
      line-height: 20px !important;
    }
  }
}
</style>
